import React, { useEffect, useState } from 'react';
import MainNav from './main-nav';
import { connect, useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import ProfileStrip from './profile-strip';
import MarketTickerNav from './market-ticker-nav';
import { SET_NEWSLETTER_LIST } from '../../../../store/actions';
import { makeApiCall } from '../../../helpers/utils';
import AdWithPlaceholder from '../../molecules/ad-with-placeholder';
import { isMobileOnly as isMobile } from 'react-device-detect';
import './ndtv-header.m.css';

const NdtvHeader = ({ pageType, userData, isHeaderCheck }) => {
  const dispatch = useDispatch();
  const headerMock = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'ndtv_header'], null),
  );
  const [mainMenu, setMainMenu] = useState(headerMock?.main_menu_list || []);
  const newsletterList = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'newsLetterList'], []),
  );
  const espConfig = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'esp_config'], {}),
  );
  const userInfo = userData?.userProfile;
  const [hideTicker, setHideTicker] = useState(false);
  const [topAdTest, setTopAdTest] = useState(false);

  useEffect(() => {
    let mounted = true;
    const WAP_URL = headerMock?.api_endpoints?.mainNav;
    const fetchNavs = async () => {
      try {
        const response = await fetch(WAP_URL);
        if (!mounted) return;

        if (response.ok) {
          const json = await response.json();
          const main = Array.isArray(json?.data) ? json.data : json;
          setMainMenu(main);
        }
      } catch (e) {
        console.error('Failed to load nav JSON', e);
      }
    };

    fetchNavs();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (newsletterList.length > 0) {
      const baseUrl = espConfig.base_url;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json, application/xml',
        mmApiKey: espConfig.api_key,
      };
      if (!userInfo?.email) {
        const list = newsletterList.map((l) => {
          return { ...l, subscribed: false };
        });
        dispatch({ type: SET_NEWSLETTER_LIST, payload: list });
      } else {
        makeApiCall(
          `${baseUrl}/api/v1/getContactDetails?email=${userInfo?.email}`,
          'GET',
          {},
          headers,
        ).then((res) => {
          if (res?.message && res?.message === 'Email does not exist') {
            return false;
          } else {
            const list = newsletterList.map((l) => {
              return { ...l, subscribed: res?.data?.[l?.data_key] === 'true' };
            });
            dispatch({ type: SET_NEWSLETTER_LIST, payload: list });
          }
        });
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (window?.location?.pathname.includes('/ad/')) {
      setTopAdTest(true);
      setHideTicker(true);
    } else {
      setHideTicker(false);
      setTopAdTest(false);
    }
  }, []);

  return (
    <header styleName="ndtv-header-section">
      <div
        styleName="AboveHeader-AdWrapper-DT"
        className="responsive-ad desktop-only content-center"
      >
        {!topAdTest && (
          <React.Fragment>
            {!isMobile && (
              <AdWithPlaceholder
                adtype="SpFwAboveHeader"
                height="90px"
                width="970px"
                adUnit="Top_728x90"
                customClass="ad-above-header-new-design"
                sizes={[
                  [728, 90],
                  [970, 90],
                ]}
              />
            )}
          </React.Fragment>
          )}
      </div>
      {isHeaderCheck?.marketStrip && !hideTicker && <MarketTickerNav pageType={pageType} userData={userData} />}
      {isHeaderCheck?.mainNav && (
        <MainNav
          isHeaderCheck={isHeaderCheck}
          mainMenu={mainMenu}
          pageType={pageType}
          userData={userData}
        />
      )}
      {isHeaderCheck?.profileStrip && <ProfileStrip />}
    </header>
  );
};

const mapStateToProps = (state) => {
  return {
    pageType: get(state, ['qt', 'pageType'], 'home-page'),
    userData: get(state, ['userData']),
    isHeaderCheck: get(state, ['qt', 'config', 'features', 'ndtv_header']),
  };
};

export default connect(mapStateToProps)(NdtvHeader);
